<pui-floating-dialog-outlet [backdropTestId]="'chatbot-backdrop'" [showBackdrop]="showBackdrop()">
    @defer (when store.isOpen()) {
        <pxl-chatbot-dialog [class.hidden]="!store.isOpen()" [fullScreen]="store.fullScreen()" />
    }
</pui-floating-dialog-outlet>
